import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import '../styles/ProductPage.scss';

export default function ProductPage() {
  const { category, id } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows
          .slice(1)
          .map((row) => {
            const obj = {};
            headers.forEach((h, i) => {
              obj[h.trim().toLowerCase()] = (row[i] || '').trim();
            });
            return obj;
          })
          .filter((item) => item.id && item.category); // только строки с id и category

        // Маппинг категорий URL -> Google Sheets
        const categoryMap = {
          laptops: 'laptops',
          processors: 'cpu',
          motherboards: 'motherboard',
          gpu: 'gpu',
          cooling: 'cooling',
          cases: 'cases',
          psu: 'psu',
          readybuilds: 'readybuilds',
          monitors: 'monitors',
          storage: 'storage',
          ram: 'ram',
          accessories: 'accessories',
        };

        // Определяем категорию
        let cat;
        if (location.pathname.startsWith('/ready-builds')) {
          cat = 'readybuilds';
        } else {
          cat =
            categoryMap[category?.toLowerCase()] ||
            category?.toLowerCase() ||
            'laptops';
        }

        // Находим товар (игнорируем регистр и пробелы в id)
        const normalize = (str) => str?.toLowerCase().replace(/\s+/g, '');
        const foundItem = items.find(
          (p) =>
            normalize(p.category) === normalize(cat) &&
            normalize(p.id) === normalize(id)
        );

        setItem(foundItem || null);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [category, id, location.pathname]);

  if (loading) return <h2>Загрузка...</h2>;
  if (!item) return <h2>Товар не найден</h2>;

  return (
    <div className="product-page">
      <img src={item.image} alt={item.name} />
      <div className="product-info">
        <h1>{item.name}</h1>
        <p>{item.description || item.specs}</p>
        <p className="price">{item.price}</p>
        <a
          href="https://t.me/talty23"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          Купить
        </a>
      </div>
    </div>
  );
}
